import { render, staticRenderFns } from "./ResultInput.vue?vue&type=template&id=5bf5fa38"
import script from "./ResultInput.vue?vue&type=script&lang=js"
export * from "./ResultInput.vue?vue&type=script&lang=js"
import style0 from "./ResultInput.vue?vue&type=style&index=0&id=5bf5fa38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports